module.exports = __webpack_public_path__ + "img/the_milk.5fb81e17.svg";